import { ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "../components/ui/card";
import { useEffect } from "react";
import { useUser } from "../hooks/useUser";

export default function ScheduleMeeting() {
  const { user } = useUser(true);

  useEffect(() => {
    if (!user) return;
    const organizationId = user.organization_id;
    if (!organizationId) return;
    if (organizationId !== "DEFAULT") {
      window.location.href = "/";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(user)]);

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-gradient-to-br from-[#549BFD]/5 via-[#7AABFA]/5 to-[#A1BBF7]/5">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-grid-slate-200/20" />

      {/* Gradient orbs */}
      <div className="pointer-events-none absolute -top-40 -left-40 h-[500px] w-[500px] rounded-full bg-[#549BFD]/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-40 -right-40 h-[500px] w-[500px] rounded-full bg-[#A1BBF7]/10 blur-3xl" />

      <div className="relative flex min-h-screen items-center justify-center p-4 sm:p-8">
        <Card className="w-full max-w-md border-none bg-white/80 shadow-2xl backdrop-blur-sm">
          <CardHeader className="space-y-4 text-center pb-2">
            <div className="mx-auto w-28 h-28 relative">
              <svg
                viewBox="0 0 199 201"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-full h-full drop-shadow-xl transition-transform duration-300 hover:scale-105"
              >
                <rect
                  y="0.378418"
                  width="198.874"
                  height="200.243"
                  rx="40"
                  fill="#010101"
                />
                <g filter="url(#filter0_i_206_5)">
                  <path
                    d="M92.9696 37.3855C97.2311 34.9082 102.494 34.9082 106.756 37.3855L150.945 63.0739C155.169 65.5292 157.767 70.0459 157.767 74.9313V126.472C157.767 131.357 155.169 135.874 150.945 138.329L106.756 164.017C102.494 166.495 97.2311 166.495 92.9696 164.017L48.7803 138.329C44.5566 135.874 41.9579 131.357 41.9579 126.472V74.9313C41.9579 70.0459 44.5566 65.5292 48.7803 63.0739L92.9696 37.3855Z"
                    fill="url(#paint0_linear_206_5)"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_i_206_5"
                    x="41.958"
                    y="35.5273"
                    width="115.81"
                    height="130.348"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="BackgroundImageFix"
                      result="shape"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="17.1443" />
                    <feComposite
                      in2="hardAlpha"
                      operator="arithmetic"
                      k2="-1"
                      k3="1"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="shape"
                      result="effect1_innerShadow_206_5"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_206_5"
                    x1="43.2866"
                    y1="102.428"
                    x2="154.724"
                    y2="102.428"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#549BFD" />
                    <stop offset="1" stopColor="#A1BBF7" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <h1 className="text-3xl font-bold tracking-tight bg-gradient-to-r from-[#549BFD] to-[#A1BBF7] bg-clip-text text-transparent">
              Dashboard Access
            </h1>
          </CardHeader>
          <CardContent className="text-center px-8">
            <p className="text-lg text-muted-foreground">
              Dashboard usage is for enterprise customers.
              <span className="block mt-1">
                To learn more, schedule a meeting
              </span>
            </p>
          </CardContent>
          <CardFooter className="flex justify-center pb-8">
            <Button
              asChild
              size="lg"
              className="group relative overflow-hidden bg-gradient-to-r from-[#549BFD] to-[#A1BBF7] hover:from-[#4181e2] hover:to-[#90a9e0] transition-all duration-300"
            >
              <a
                href="https://calendar.app.google/Ev1K7cAx1PFteuWZ8"
                rel="noopener noreferrer"
                target="_blank"
                className="relative z-10 flex items-center"
              >
                Schedule a Meeting
                <ArrowRight className="ml-2 h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}
